import { useEffect } from "react";
import { FaCheck, FaTimes } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import FromLayout from "../../../component/FromLayout";
import { usePaymentCompleteMutation } from "../../../store/api/admin/paymentSlice";
import { logOutTempUser } from "../../../store/reducer/UserReducer";

const PaymentComplete = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { search } = useLocation();
  const { tempData } = useSelector((state) => state.UserReducer);

  const queryParams = new URLSearchParams(search);

  const resultCode = queryParams.get("resultCode");
  const cardType = queryParams.get("cardType");
  const transactionId = queryParams.get("transactionId");
  const referenceId = queryParams.get("referenceId");
  const amount = queryParams.get("amount");
  const orderNumber = queryParams.get("orderNumber");
  const paymentMethodId = queryParams.get("paymentMethodId");
  const completeToken = queryParams.get("ct");

  const { user } = useSelector((state) => state.UserReducer);
  const role = user?.role === "super_admin" ? "admin" : user?.role;

  // subscription
  const [paymentComplete, { isLoading }] = usePaymentCompleteMutation();

  const handleSubmit = async () => {
    toast.dismiss();

    const payload = {
      referenceId,
      paymentMethodId,
      resultCode: Number(resultCode),
      paymentStatus: "Completed",
      transactionId,
      completeToken,
    };

    try {
      let response = await paymentComplete(payload).unwrap();
      if (response.statusCode === 200) {
        // toast.success(response.message);
        // dispatch(
        //   logInUser({
        //     ...tempData,
        //     status: "active",
        //     is_payment_active: 1,
        //     payment_status: "Completed",
        //     subscription_end_date: response.data.end_subscription_date,
        //   }),
        // );
        dispatch(logOutTempUser());
      }
    } catch (err) {
      // const message =
      //   err?.data?.message || err.message || "Something went wrong!";
      // toast.error(message);
    }
  };

  useEffect(() => {
    if (
      tempData &&
      tempData?.status === "payment_pending" &&
      resultCode === "0"
    ) {
      handleSubmit();
    }
  }, [resultCode]);

  const handleGoDashboard = () => {
    dispatch(logOutTempUser());
    navigate("/");
  };

  return (
    <FromLayout
    // title={`${t("parent")} & ${t("student")} ${t("registration")} ${t("fee")}`}
    >
      <div className="payment-complete">
        <div className="p-0">
          {resultCode === 0 || resultCode === "0" ? (
            <div className="payment-success parent">
              <div className="success-card">
                <div className="success-icon">
                  <FaCheck />
                </div>
                <h2>Payment Successful!</h2>
                <p>
                  Thank you for your payment. Your transaction has been
                  completed.
                </p>

                <div className="order-details">
                  <div className="detail-row">
                    <span>Order ID:</span>
                    <span>{orderNumber}</span>
                  </div>
                  <div className="detail-row">
                    <span>Amount Paid:</span>
                    <span>${amount / 100}</span>
                  </div>
                  <div className="detail-row">
                    <span>Payment Method:</span>
                    <span>{cardType}</span>
                  </div>
                </div>

                <div>
                  <button
                    type="button"
                    className="btn btn-primary"
                    disabled={isLoading}
                    onClick={handleGoDashboard}
                  >
                    {isLoading ? "Processing..." : "Go to Login"}
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <div className="payment-success parent">
              <div className="success-card">
                <div className="success-icon failed-icon">
                  <FaTimes />
                </div>
                <h2>Payment Failed</h2>
                <p>
                  Unfortunately, your payment could not be processed. Please
                  check your card details or try again later.
                </p>

                <div className="order-details">
                  <div className="detail-row">
                    <span>Order ID:</span>
                    <span>{orderNumber}</span>
                  </div>
                </div>

                <div>
                  <button
                    type="button"
                    className="btn btn-primary btn-failed"
                    onClick={() => navigate("/payment")}
                  >
                    Try Again
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </FromLayout>
  );
};

export default PaymentComplete;
